import eventQueue from '../queue';
function attachEventListener() {
    eventQueue.on('incorrect_platform_given', function (_a) {
        var fireClientEvent = _a.fireClientEvent;
        fireClientEvent('incorrect_platform_given', {});
    });
}
attachEventListener();
